module.exports = __webpack_public_path__ + "static/GlitchlessSonyax5b-bd1354f9df45d756c381855daf923e18.png";